import * as Yup from 'yup';

export const patientValidationSchema = Yup.object().shape({
  PatientName: Yup.string()
  .matches(/^[A-Za-z\s]+$/, 'Patient name should only contain letters')
  .required('Patient name is required'),
  Email: Yup.string().email('Invalid email').required('Email is required'),
  PhoneNo: Yup.string().min(11,"Phone no must be 11 digit").required('Phone number is required'),
});
